import { render } from "./OverviewWrap.vue?vue&type=template&id=4d4cdf11&scoped=true"
import script from "./OverviewWrap.vue?vue&type=script&lang=js"
export * from "./OverviewWrap.vue?vue&type=script&lang=js"

import "./OverviewWrap.vue?vue&type=style&index=0&id=4d4cdf11&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d4cdf11"]])

export default __exports__